// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b05d8aa5","645":"57784a58","685":"164a511f"}[chunkId] + ".chunk.js";
};